import { render } from "./Upload.vue?vue&type=template&id=0789bb70&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"

import "./Upload.vue?vue&type=style&index=0&id=0789bb70&scoped=true&lang=css"

import exportComponent from "/mnt/volume-nbg1-3/html/musikalienverleih/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0789bb70"]])

export default __exports__